export default {
  get_all: { method: "get", url: "api/parceiros" },
  by_id: { method: "get", url: "api/parceiro/update/naturezas{/id}" },
  show: { method: "get", url: "api/parceiros{/id}" },
  store: { method: "post", url: "api/parceiros" },
  update_partner: { method: "post", url: "api/parceiro/update" },
  update: { method: "put", url: "api/parceiros{/id}" },
  delete: { method: "delete", url: "api/parceiros{/id}" },
  to_select: { method: "get", url: "api/parceiros/to-select" },
};
